export default class SendAppCardRenderAnalytics {
  constructor(context) {
    this.context = context;
  }

  run(renderEventData = {}) {
    this.context.analytics.track('AppCard Rendered', { ...renderEventData });
  }
}
